import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import './styles.less'
import InviteToProjectWidget from '../../widgets/projectProposal/inviteToProject/InviteToProjectWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getInviteAcceptForm, getInviteForm } from '../../redux/actions/inviteToProject'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import TopLevelNav from '../../components/TopLevelNav'
import classNames from 'classnames'

export default function InviteToProjectAccept() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const { se } = useParams()
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let response

      if (se) {
        response = await getInviteAcceptForm(se)
      } else {
        response = await getInviteForm(projectId, 1)
      }

      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load inviteToProject se : ', se)
    if (se || projectId) {
      handleGetSchema()
    }
  }, [])

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          <div
            className={classNames('rs-sidebar-media-backdrop', {
              'media-sidebar-show': false,
            })}
          />
          <TopLevelNav />
          {/* <PageToolbar /> */}

          <div
            className={classNames('content', {
              'not-expanded': true,
            })}
          >
            <>
              <ContentHeader header={schema.header} subHeader={schema.subHeader} />

              {schema?.forms?.inviteProject && (
                <InviteToProjectWidget
                  showCommandButton={true}
                  schema={schema.forms.inviteProject}
                  isAcceptF={true}
                />
              )}
            </>
          </div>
        </>
      )}
    </>
  )
}
